import { useI18nContext } from '@lemonade-hq/nuiza';
import { useEffect, useRef } from 'react';

export const partytownConfig = ['dataLayer.push', 'fbq', 'ttq.track', 'ttk.page', 'ttk.load', 'twitterq.push'];

interface UseGTMProps {
  readonly enabled: boolean;
  readonly isPartytownEnabled?: boolean;
}

export const useGTM = ({ enabled, isPartytownEnabled }: UseGTMProps): void => {
  const gtmLoaded = useRef(false);
  const { region } = useI18nContext();

  useEffect(() => {
    if (gtmLoaded.current || !enabled) return;

    gtmLoaded.current = true;
    const script = document.createElement('script');
    script.type = isPartytownEnabled ? 'text/partytown' : 'text/javascript';
    script.id = 'gtm';
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.lemonade.com/dtoc/?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','${process.env.GTM_ID}');`;
    document.head.append(script);

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    window.dataLayer ??= [];
    window.dataLayer.push({ country: region.toUpperCase() });
    window.dispatchEvent(new CustomEvent('ptupdate'));
  }, [enabled, region, isPartytownEnabled]);
};
